// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#CybotCookiebotDialog {
  font-family: var(--font-body) !important;
}

/* Non-rounded buttons */
.CybotCookiebotDialogBodyButton {
  border-radius: 30px !important;
  font-weight: 400 !important;
}

/* Link */
#CybotCookiebotDialogBodyContentText > a {
  font-weight: 400 !important;
  text-decoration: underline !important;
}

/* Remove CookieBot branding on the banner */
a#CybotCookiebotDialogPoweredbyCybot,
div#CybotCookiebotDialogPoweredByText {
  display: none;
}

/* Remove CookieBot branding on the Privacy trigger */
#CookiebotWidget .CookiebotWidget-body .CookiebotWidget-main-logo {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/cookiebot-consent-dialog/cookiebot-consent-dialog.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;AACF;;AAEA,wBAAA;AACA;EACE,8BAAA;EACA,2BAAA;AACF;;AAEA,SAAA;AACA;EACE,2BAAA;EACA,qCAAA;AACF;;AAEA,4CAAA;AACA;;EAEE,aAAA;AACF;;AAEA,qDAAA;AACA;EACE,aAAA;AACF","sourcesContent":["#CybotCookiebotDialog {\n  font-family: var(--font-body) !important;\n}\n\n/* Non-rounded buttons */\n.CybotCookiebotDialogBodyButton {\n  border-radius: 30px !important;\n  font-weight: 400 !important;\n}\n\n/* Link */\n#CybotCookiebotDialogBodyContentText > a {\n  font-weight: 400 !important;\n  text-decoration: underline !important;\n}\n\n/* Remove CookieBot branding on the banner */\na#CybotCookiebotDialogPoweredbyCybot,\ndiv#CybotCookiebotDialogPoweredByText {\n  display: none;\n}\n\n/* Remove CookieBot branding on the Privacy trigger */\n#CookiebotWidget .CookiebotWidget-body .CookiebotWidget-main-logo {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
